var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-header',[_vm._v("Inställningar Fortnox")]),_c('b-card-body',[_c('b-row',[_c('b-col',[_c('label')])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }